import { lazyReadOcsSettings } from 'owa-ocs-service-gql';
import { default as updateConditionalFormattingRules } from '../utils/updateConditionalFormattingRules';
import type { MailboxInfo } from 'owa-client-types';
import { getConditionalFormattingSettingName } from '../utils/getConditionalFormattingScenarioSettingUtils';
import type { ConditionalFormattingScenario } from '../store/schema/ConditionalFormattingScenarioType';

export async function fetchConditionalFormattingRulesService(
    mailboxInfo: MailboxInfo,
    scenario: ConditionalFormattingScenario
): Promise<void> {
    const ocsResponse: any[] = await lazyReadOcsSettings.importAndExecute(mailboxInfo, 'ACCOUNT', [
        getConditionalFormattingSettingName(scenario),
    ]);
    if (ocsResponse[0]?.value) {
        updateConditionalFormattingRules(
            mailboxInfo,
            JSON.parse(ocsResponse[0]?.value as string),
            scenario,
            true /* is from fetch*/
        );
    } else {
        //set empty value
        updateConditionalFormattingRules(mailboxInfo, [], scenario);
    }
}
